var _defs, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoData = function SvgNoData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    height: 20,
    width: 20,
    viewBox: "0 0 122.88 122.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill-rule:evenodd;}.cls-3{fill:#d92d27;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,29.38,93.49,98.92A49.31,49.31,0,0,1,24,29.38ZM101.68,90,32.92,21.2A49.24,49.24,0,0,1,96.3,26.57a49,49,0,0,1,14.45,34.87h0A49.12,49.12,0,0,1,101.68,90Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.57,63.55h-11a1.07,1.07,0,0,0-1.07,1.06V86.44a1.08,1.08,0,0,0,1.07,1.07h11a1.08,1.08,0,0,0,1.07-1.07V64.61a1.07,1.07,0,0,0-1.07-1.06ZM93,34.54H82a1.08,1.08,0,0,0-1.07,1.07V86.44A1.08,1.08,0,0,0,82,87.51H93a1.08,1.08,0,0,0,1.07-1.07V35.61A1.07,1.07,0,0,0,93,34.54ZM36.87,74.3h-11a1.08,1.08,0,0,0-1.07,1.07V86.44a1.08,1.08,0,0,0,1.07,1.07h11a1.07,1.07,0,0,0,1.06-1.07V75.37a1.07,1.07,0,0,0-1.06-1.07ZM74.28,51h-11A1.07,1.07,0,0,0,62.19,52V86.44a1.08,1.08,0,0,0,1.07,1.06h11a1.07,1.07,0,0,0,1.06-1.06V52A1.07,1.07,0,0,0,74.28,51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.44,122.88A61.31,61.31,0,1,0,38,118.22a61.29,61.29,0,0,0,23.49,4.66ZM101.68,90,32.93,21.2a49.44,49.44,0,0,1,47.38-5.34A49.53,49.53,0,0,1,107,42.58a49,49,0,0,1,3.73,18.86h0A48.93,48.93,0,0,1,101.68,90ZM24,29.38,93.5,98.92A49.32,49.32,0,0,1,24,29.38Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data.90c8d6ca.svg";
export { ForwardRef as ReactComponent };